// src/pages/ja/Terms_ja.js
import React from "react";
import { Link } from "react-router-dom";
import "../Terms.css";

function Terms() {
  return (
    <div className="terms-page" lang="ja">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/ja" className="brand-link" aria-label="日本語トップへ戻る">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="terms-title">
        <article className="generator-card terms-card" aria-labelledby="terms-title">
          <header className="terms-header">
            <h1 id="terms-title" className="card-title">TooLoves.net 利用規約</h1>
            <p className="card-subtitle terms-updated">
              最終更新:
              <time dateTime="2025-10-22"> 2025年10月22日（KST）</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              本利用規約（「本規約」）は、TooLoves.net の運営者（「運営者」）が運営するウェブサイト TooLoves.net（以下「本サイト」）の
              利用に関し、会員および訪問者（「利用者」）が遵守すべき権利、義務および責任を定めるものです。
              本サイトを利用することで、利用者は本規約に同意したものとみなされます。
            </p>
          </section>

          <section className="terms-section" id="purpose">
            <h2 className="section-title">1. 利用目的</h2>
            <p>
              TooLoves.net は、QRコード生成、画像ウォーターマーク（透かし）、AI写真のEXIF抽出などの各種オンラインツールを提供し、
              利用者が迅速かつ便利にデジタル作業を行えるよう支援します。
            </p>
          </section>

          <section className="terms-section" id="user-duties">
            <h2 className="section-title">2. 利用者の義務</h2>
            <ol>
              <li>利用者は本サイトの利用にあたり、関係法令および本規約を遵守しなければなりません。</li>
              <li>本サイトの機能を悪用したり、違法・有害な目的で使用してはなりません。</li>
              <li>他者の権利（著作権、肖像権、個人情報など）を侵害する行為を禁止します。</li>
              <li>
                次の行為は厳格に禁止されます：
                リバースエンジニアリング、回避・迂回行為、自動化されたデータ収集、サービス妨害、
                セキュリティ侵害、マルウェアの配布、違法情報の掲載、他人のなりすまし、
                過剰なリクエストによる過負荷の発生 など。
              </li>
            </ol>
          </section>

          <section className="terms-section" id="service-changes">
            <h2 className="section-title">3. サービスの提供および変更</h2>
            <ol>
              <li>運営者は本サイトの安定運用のため、必要に応じてサービス内容を変更・中断・終了することがあります。</li>
              <li>変更後も利用者がサービスを継続して利用する場合、変更後の規約に同意したものとみなされます。</li>
              <li>
                利用者が本規約または関係法令に違反した場合、またはサイト運営上必要と判断される場合、
                運営者は予告や同意なく、利用者のサービスへのアクセスを制限または遮断することができます。
              </li>
            </ol>
          </section>

          <section className="terms-section" id="copyright">
            <h2 className="section-title">4. 著作権</h2>
            <ol>
              <li>本サイトに掲載されたすべてのコンテンツ（テキスト、画像、コード等）の著作権は運営者に帰属します。</li>
              <li>
                利用者が本サービスを通じて生成・アップロード・送信または他者に提供したすべての情報およびコンテンツ（以下「ユーザー生成コンテンツ」）の著作権は当該利用者に帰属します。
              </li>
              <li>利用者は個人的・非商用目的に限りコンテンツを利用でき、本サイト内の共有ボタンを用いる方法以外での配布は禁止します。</li>
            </ol>
          </section>

          <section className="terms-section" id="liability">
            <h2 className="section-title">5. 責任の制限</h2>
            <ol>
              <li>運営者は、利用者が本サイトを通じて生成したデータの正確性・完全性・安全性・有害性を保証しません。</li>
              <li>本サイトの利用に起因して利用者に生じた損害について、運営者は法令で許容される範囲内で責任を負いません。</li>
              <li>ユーザー生成コンテンツに関連して発生する民事・刑事上の責任は全て当該利用者が負い、運営者は一切の責任を負いません。</li>
            </ol>
          </section>

          <section className="terms-section" id="privacy">
            <h2 className="section-title">6. 個人情報の保護</h2>
            <p>
              本サイト利用時に収集される個人情報は、
              <Link to="/ja/privacy" className="link" aria-label="プライバシーポリシーを見る">
                プライバシーポリシー
              </Link>
              に従い安全に取り扱われます。
            </p>
          </section>

          <section className="terms-section" id="changes">
            <h2 className="section-title">7. 規約の変更</h2>
            <p>運営者は必要に応じて本規約を改定することがあり、変更後の規約はサイト上の告知または通知により周知します.</p>
            <p>利用者が変更後も本サイトの利用を継続した場合、変更後の規約に同意したものとみなされます。</p>
          </section>

          <section className="terms-section" id="disputes">
            <h2 className="section-title">8. 紛争解決</h2>
            <p>本規約およびサービスに関する紛争は大韓民国の法律を準拠法とし、運営者の居住地を管轄する裁判所を第一審の管轄裁判所とします。</p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">9. お問い合わせ</h2>
            <p>
              サービスに関するお問い合わせは{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="helptooloves@gmail.com へメールを送る"
              >
                helptooloves@gmail.com
              </a>
              までご連絡ください。
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/ja" className="btn" aria-label="日本語トップへ戻る">
              日本語トップへ戻る
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">© 2025 TooLoves. All rights reserved.</footer>
    </div>
  );
}

export default Terms;